/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
  useImperativeHandle,
  ForwardRefRenderFunction,
  forwardRef,
} from 'react';
import ReactQuill from 'react-quill';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { format, set } from 'date-fns';

import { AxiosResponse } from 'axios';
import api from '~/services/api';
import getValidationErros from '~/utils/getValidationsErrors';

import { Container } from './styles';
import Input from '~/components/Input';
import Select, { IOption } from '~/components/Select';
import InputDate from '~/components/InputDate';
import Questions, { IAlternative, IQuestion } from '../../Questions';
import InputAddress, { IAddress } from '~/components/InputAddress';
import Loading from '~/components/Loading';
import InputMask from '~/components/InputMask';
import { useLocation } from 'react-router-dom';
import { KrClose } from '~/components/KoroIcons';

interface IType {
  id: number;
  name: string;
}

export interface IInitialData {
  free?: boolean;
  event_id?: number;
  type_id?: number;
  address_id?: number;
  contract_id?: number;
  name: string;
  type: string;
  date: Date;
  hour: string;
  end_date: Date;
  end_hour: string;
  sales_end_date?: Date;
  status: number;
  address?: string;
  street?: string;
  number?: string;
  city?: string;
  neighborhood?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  full_address?: string;
  description: string;
  questions?: IQuestion[];
  target_registration?: number;
  target_revenue?: number;
  target_avarage_ticket?: number;
  fill_before?: number;
  unique_ticket?: boolean;
}

export interface IFormData {
  name: string;
  type: string;
  date: string;
  end_date: string;
  status: string;
  address?: string;
  street?: string;
  number?: string;
  city?: string;
  neighborhood?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  full_address?: string;
  description: string;
}

interface IStatus {
  id: number;
  name: string;
}

interface IBasicData {
  sold?: boolean;
  initialData?: IInitialData;
  onChangeEventName(value: string): void;
  onChangeType(option: IOption): void;
  onChange(data: IInitialData): void;
}

export interface IBasicDataHandle {
  submit: () => void;
}

const BasicData: ForwardRefRenderFunction<IBasicDataHandle, IBasicData> = (
  { sold, initialData, onChangeEventName, onChangeType, onChange },
  ref
) => {
  const location = useLocation();
  const formRef = useRef<FormHandles>(null);
  const [types, setTypes] = useState<IOption[]>([]);
  const [date, setDate] = useState<Date>(new Date());
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [address, setAddress] = useState('');
  const [description, setDescription] = useState('');
  const [street, setStreet] = useState('');
  const [number, setNumber] = useState('');
  const [neighborhood, setNeighborhood] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [country, setCountry] = useState('');
  const [questions, setQuestions] = useState<IQuestion[]>([]);
  const [oldQuestions, setOldQuestions] = useState<IQuestion[]>([]);
  const [typeId, setTypeId] = useState<number | undefined>(undefined);
  const [eventId, setEventId] = useState<number | undefined>(undefined);
  const [addressId, setAddressId] = useState<number | undefined>(undefined);
  const [initialBasicData, setInitialBasicData] = useState<IFormData>(
    {} as IFormData
  );
  const [firstLoad, setFirstLoad] = useState(true);
  const [status, setStatus] = useState<IOption[]>([
    {
      id: 0,
      value: 'Cadastrando',
      selected: true,
    },
  ]);
  const [eventStatus, setEventStatus] = useState('Rascunho');
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('Carregando...');
  const [startHour, setStartHour] = useState('');
  const [endHour, setEndHour] = useState('');
  const [hourStartError, setHourStartError] = useState('');
  const [hourEndError, setHourEndError] = useState('');
  const [events, setEvents] = useState<IInitialData[]>([]);
  const [fileRegulation, setFileRegulation] = useState<File | null>(null);

  useEffect(() => {
    api.get('events/organizer').then((response) => {
      setEvents(response.data);
    });
  }, []);

  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      setTypeId(initialData.type_id);
      setEventId(initialData.event_id);
      setAddressId(initialData.address_id);

      if (initialData.street) {
        setStreet(initialData.street);
      }

      if (initialData.number) {
        setNumber(initialData.number);
      }

      if (initialData.neighborhood) {
        setNeighborhood(initialData.neighborhood);
      }

      if (initialData.city) {
        setCity(initialData.city);
      }

      if (initialData.state) {
        setState(initialData.state);
      }

      if (initialData.zipCode) {
        setZipCode(initialData.zipCode);
      }

      if (initialData.country) {
        setCountry(initialData.country);
      }

      if (initialData.full_address) {
        setAddress(initialData.full_address);
      }

      if (initialData.hour) {
        setStartHour(initialData.hour);
      }

      if (initialData.end_hour) {
        setEndHour(initialData.end_hour);
      }

      setInitialBasicData({
        name: initialData.name,
        type: initialData.type,
        date: format(initialData.date, 'dd/MM/yyyy'),
        end_date: format(initialData.end_date, 'dd/MM/yyyy'),
        status: initialData.status ? initialData.status.toString() : '0',
        address: initialData.address,
        street: initialData.street,
        number: initialData.number,
        city: initialData.city,
        neighborhood: initialData.neighborhood,
        state: initialData.state,
        zipCode: initialData.zipCode,
        country: initialData.country,
        full_address: initialData.full_address,
        description: initialData.description,
      });
      setDate(initialData.date);
      setEndDate(initialData.end_date);
      setDescription(initialData.description);

      if (initialData.questions) {
        setQuestions(initialData.questions);
        // Deep clone para evitar que mutações feitas no componente Questions
        // (push/edição de alternativas in-place) alterem também oldQuestions,
        // o que impedia a detecção de mudanças no submit
        setOldQuestions(JSON.parse(JSON.stringify(initialData.questions)));
      }
    }
  }, [initialData]);

  useEffect(() => {
    if (firstLoad && initialData && Object.keys(initialData).length > 0) {
      api.get<IStatus[]>('events-status').then((response) => {
        const data = response.data.map<IOption>((statusData) => ({
          id: statusData.id,
          value: statusData.name,
          selected: !!(initialData && initialData.status === statusData.id),
        }));

        let statusSelected = data.find((statusData) => statusData.selected);

        if (!statusSelected) {
          statusSelected = {
            id: 0,
            value: 'Cadastrando',
            selected: true,
          };
        }
        setStatus([statusSelected]);
        if (statusSelected?.value) {
          setFirstLoad(false);
          setEventStatus(statusSelected.value);
        }
      });
    } else if (status.length === 0) {
      setStatus([
        {
          id: 0,
          value: 'Cadastrando',
          selected: true,
        },
      ]);
    }
  }, [initialData, firstLoad, eventStatus, status.length]);

  const handleChangeType = useCallback(
    (option) => {
      onChangeType(option);
      setTypeId(option.id);
    },
    [onChangeType]
  );

  const handleLoadTypes = useCallback(
    async (search = '') => {
      const response = await api.get<IType[]>('events-types', {
        params: { search, isOrganizer: true },
      });
      const data = response.data.map<IOption>((type) => ({
        id: type.id,
        value: type.name,
        selected: !!(initialData && parseInt(initialData.type, 10) === type.id),
      }));
      setTypes(data);
      const optionSelected = data.find((type) => type.selected);
      if (optionSelected) {
        handleChangeType(optionSelected);
      }
    },
    [handleChangeType, initialData]
  );

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }], // Tamanhos de cabeçalhos
      ['bold', 'italic', 'underline'], // Estilos de texto
      [{ list: 'ordered' }, { list: 'bullet' }], // Listas
      [{ align: [] }], // Alinhamento
      ['link'], // Links
    ],
  };

  useEffect(() => {
    handleLoadTypes();
  }, [handleLoadTypes]);

  const handleChangeDate = useCallback((value) => {
    setDate(value);
  }, []);

  const handleChangeEndDate = useCallback((value) => {
    setEndDate(value);
  }, []);

  const handleDescription = useCallback((e) => {
    setDescription(e);
  }, []);

  const handleChangeAddress = useCallback((addressData: IAddress) => {
    setStreet(addressData.street);
    setNumber(addressData.number);
    setNeighborhood(addressData.neighborhood);
    setCity(addressData.city);
    setState(addressData.state);
    setZipCode(addressData.zipCode);
    setCountry(addressData.country);
  }, []);

  const handleChangeAddressFormatted = useCallback((addressData) => {
    setAddress(addressData);
  }, []);

  const addressMap = useMemo(() => {
    return address || 'Brazil';
  }, [address]);

  const handleChangeQuestions = useCallback((questionsData) => {
    setQuestions(questionsData);
  }, []);

  const isValidTime = useCallback((value: string): boolean => {
    let isValid = true;

    isValid = parseInt(value.charAt(0), 10) <= 2;

    if (isValid && value.charAt(1)) {
      isValid =
        value.charAt(0) === '2' ? parseInt(value.charAt(1), 10) <= 3 : true;
    }

    if (isValid && value.charAt(3)) {
      isValid = parseInt(value.charAt(3), 10) <= 5;
    }

    if (value.length === 5) {
      if (isValid) {
        const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
        isValid = regex.test(value);
      }
    }

    return isValid;
  }, []);

  const handleChangeStartHour = useCallback(
    (e) => {
      const { value } = e.target;

      if (value !== '') {
        if (isValidTime(value)) {
          setStartHour(value);
          setHourStartError('');
        } else {
          setHourStartError('Horário inválido');
        }
      } else {
        setHourStartError('');
      }
    },
    [isValidTime]
  );

  const handleChangeEndHour = useCallback(
    (e) => {
      const { value } = e.target;

      if (value !== '') {
        if (isValidTime(value)) {
          setEndHour(value);
          setHourEndError('');
        } else {
          setHourEndError('Horário inválido');
        }
      } else {
        setHourEndError('');
      }
    },
    [isValidTime]
  );

  const handleSubmit = useCallback(
    async (data) => {
      if (loading) return;
      const hasNewAlternative = questions.some((q) =>
        q.alternatives?.some((alt) => alt.new)
      );
      if (hasNewAlternative) {
        Swal.fire({
          icon: 'warning',
          title: 'Finalize as alternativas',
          text: 'Você precisa salvar todas as alternativas antes de enviar.',
        });
        return;
      }
      const allQuestions = questions.filter(
        (question) => !question.question?.trim()
      );

      const hasEmptyAlternatives = questions.some(
        (question) =>
          question.alternatives?.length === 0 && question.type !== 'free-text'
      );

      if (hasEmptyAlternatives) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Perguntas de múltipla escolha ou escolha única devem ter ao menos uma alternativa.',
        });
        return;
      }

      if (questions && allQuestions.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Todos os campos de pergunta devem ser preenchidos.',
        });
        return;
      }
      try {
        setLoading(true);
        setLoadingText('Salvando...');
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string()
            .required('O nome é obrigatório')
            // .test(
            //   'validName',
            //   'Permitido apenas letras, números, espaços e hífens',
            //   (value) => /^[a-zA-ZÀ-ÿ0-9\s-]*$/.test(value || '')
            // )
            .test(
              'nameExists',
              'Já existe um evento com esse nome',
              (value) => {
                if (location.pathname.includes('editar-evento')) {
                  return !events.some(
                    (event) =>
                      event.name === value &&
                      (event.event_id ?? (event as any).id) !== eventId
                  );
                }
                return !events.some((event) => event.name === value);
              }
            ),
          type: Yup.string().required('O tipo é obrigatório'),
          date: Yup.string()
            .required('A data de inicio é obrigatória')
            .test(
              'validDate',
              `A data do evento não poderá ser menor que a data de hoje`,
              () => {
                return new Date(data.date) >= new Date();
              }
            ),
          end_date: Yup.string()
            .required('A data de fim é obrigatória')
            .test(
              'validDate',
              `A data final do evento não poderá ser menor que a data de início do evento`,
              () => {
                return (
                  new Date(data.end_date).setHours(0, 0, 0, 0) >=
                  new Date(data.date).setHours(0, 0, 0, 0)
                );
              }
            )
            .test(
              'validDate',
              `A data final do evento não poderá ser menor que a data de hoje`,
              () => {
                return new Date(data.end_date) > new Date();
              }
            ),
          address: Yup.string().required('O endereço é obrigatório'),
          description: Yup.string().required('A descrição é obrigatória'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const addressFormData = {
          street: data.street,
          number: data.number,
          city: data.city,
          neighborhood: data.neighborhood,
          state: data.state,
          zip_code: data.zipCode,
          country: data.country,
          full_address: data.address,
        };

        let responseAddress: AxiosResponse;
        if (addressId) {
          responseAddress = await api.put(
            `addresses/${addressId}`,
            addressFormData
          );
        } else {
          responseAddress = await api.post('addresses', addressFormData);
        }

        setAddressId(responseAddress.data.id);

        const formData = {
          type_id: typeId,
          status_id: data.status === '0' ? undefined : data.status,
          address_id: responseAddress.data.id,
          name: data.name.trim(),
          description: data.description.trim(),
          date: format(new Date(data.date), 'yyyy-MM-dd HH:mm:ss'),
          hour: data.hour,
          end_date: format(new Date(data.end_date), 'yyyy-MM-dd HH:mm:ss'),
          end_hour: data.end_hour,
        };

        let response: AxiosResponse;
        if (eventId) {
          response = await api.put(`events/organizer/${eventId}`, formData);
        } else {
          response = await api.post('events/organizer', formData);
        }

        setEventId(response.data.id);

        if (fileRegulation) {
          const regulationFormData = new FormData();
          regulationFormData.append('file', fileRegulation);
          regulationFormData.append('source_id', String(response.data.id));
          regulationFormData.append('source_type', 'event');

          await api.post('ai/embeddings/upload', regulationFormData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });

          setFileRegulation(null);
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const questionsCopy = JSON.parse(JSON.stringify(questions)) as any;

        const deletedQuestions = oldQuestions.filter((question) =>
          oldQuestions.length > 0
            ? !questions.some((questionData) => question.id === questionData.id)
            : false
        );

        if (deletedQuestions.length > 0) {
          for (const question of deletedQuestions) {
            if (question.alternatives && question.alternatives.length > 0) {
              for (const alternative of question.alternatives) {
                try {
                  if (!alternative.new) {
                    await api.delete(`alternatives/${alternative.id}`);
                  }
                } catch (error) {
                  // console.log(alternative.id);
                }
              }
            }

            await api.delete(`questions/${question.id}`);
          }
        }

        const updatedQuestions = oldQuestions.filter((question) =>
          oldQuestions.length > 0
            ? questions.some((questionData) => question.id === questionData.id)
            : false
        );

        if (updatedQuestions && updatedQuestions.length > 0) {
          for (const question of updatedQuestions) {
            const questionSelected = questions.find(
              (questionData) => question.id === questionData.id
            );

            if (JSON.stringify(questionSelected) !== JSON.stringify(question)) {
              let question_type_id = 1;

              if (questionSelected?.type === 'unique-choice') {
                question_type_id = 2;
              }

              if (questionSelected?.type === 'multiple-choice') {
                question_type_id = 3;
              }

              const questionFormData = {
                event_id: response.data.id,
                question_type_id,
                name: questionSelected?.question,
                order: questionSelected?.order,
                suspended: questionSelected?.suspended,
                required: questionSelected?.isRequired,
              };

              await api.put(`questions/${question.id}`, questionFormData);

              const questionIndex = questionsCopy.findIndex(
                (questionData: IQuestion) => questionData.id === question.id
              );

              if (question.alternatives && question.alternatives.length > 0) {
                const deletedAlternatives = question?.alternatives?.filter(
                  (alternative) =>
                    !questionSelected?.alternatives?.some(
                      (alternativeData) => alternative.id === alternativeData.id
                    )
                );

                if (deletedAlternatives && deletedAlternatives.length > 0) {
                  for (const alternative of deletedAlternatives) {
                    await api.delete(`alternatives/${alternative.id}`);
                  }
                }

                const updatedAlternatives = question.alternatives.filter(
                  (alternative) =>
                    questionSelected?.alternatives?.some(
                      (alternativeData) => alternative.id === alternativeData.id
                    )
                );

                if (updatedAlternatives.length > 0) {
                  for (const alternative of updatedAlternatives) {
                    const alternativeSelected =
                      questionSelected?.alternatives?.find(
                        (alternativeData) =>
                          alternative.id === alternativeData.id
                      );
                    const alternativeIndex = question.alternatives.findIndex(
                      (alternativeData) => alternative.id === alternativeData.id
                    );

                    if (
                      JSON.stringify(alternativeSelected) !==
                      JSON.stringify(alternative)
                    ) {
                      const alternativeFormData = {
                        question_id: question.id,
                        name: alternative.text,
                        order: alternativeIndex + 1,
                      };

                      await api.put(
                        `alternatives/${alternative.id}`,
                        alternativeFormData
                      );
                    }
                  }
                }

                const newAlternatives = questionSelected?.alternatives?.filter(
                  (alternative) =>
                    !question?.alternatives?.some(
                      (alternativeData) => alternative.id === alternativeData.id
                    )
                );

                if (newAlternatives && newAlternatives.length > 0) {
                  let position =
                    question.alternatives.length - newAlternatives.length + 1;
                  for (const alternative of newAlternatives) {
                    if (!alternative.new) {
                      const alternativeFormData = {
                        question_id: question.id,
                        name: alternative.text,
                        order: position,
                      };

                      const responseAlternative = await api.post(
                        'alternatives',
                        alternativeFormData
                      );

                      if (questionsCopy[questionIndex].alternatives) {
                        const alternativeIndex = questionsCopy[
                          questionIndex
                        ].alternatives.findIndex(
                          (alternativeData: IAlternative) =>
                            alternativeData.id === alternative.id
                        );

                        if (alternativeIndex >= 0)
                          questionsCopy[questionIndex].alternatives[
                            alternativeIndex
                          ].id = responseAlternative.data.id;
                      }

                      position += 1;
                    }
                  }
                }
              }
            }
          }
        }

        const newQuestions = questions.filter((question) =>
          oldQuestions.length > 0
            ? !oldQuestions.some(
                (questionData) => question.id === questionData.id
              )
            : true
        );

        if (newQuestions && newQuestions.length > 0) {
          for (const question of newQuestions) {
            let question_type_id = 1;

            if (question.type === 'unique-choice') {
              question_type_id = 2;
            }

            if (question.type === 'multiple-choice') {
              question_type_id = 3;
            }

            const questionFormData = {
              event_id: response.data.id,
              question_type_id,
              name: question.question,
              order: question.order,
              required: question.isRequired,
              suspended: question.suspended,
            };

            const responseQuestion = await api.post(
              'questions',
              questionFormData
            );

            const questionIndex = questionsCopy.findIndex(
              (questionData: IQuestion) => questionData.id === question.id
            );

            if (questionIndex >= 0) {
              questionsCopy[questionIndex].id = responseQuestion.data.id;
            }

            let alternativeIndex = 0;
            if (question.alternatives && question.alternatives.length > 0) {
              let position = 1;
              for (const alternative of question.alternatives) {
                if (!alternative.new) {
                  const alternativeFormData = {
                    question_id: responseQuestion.data.id,
                    name: alternative.text,
                    order: position,
                  };

                  const responseAlternative = await api.post(
                    'alternatives',
                    alternativeFormData
                  );

                  if (questionsCopy[questionIndex].alternatives) {
                    questionsCopy[questionIndex].alternatives[
                      alternativeIndex
                    ].id = responseAlternative.data.id;
                  }

                  position += 1;
                }

                alternativeIndex += 1;
              }
            } else {
              const alternativeFormData = {
                question_id: responseQuestion.data.id,
                name: '',
                order: 1,
              };

              await api.post('alternatives', alternativeFormData);
            }
          }
        }

        setQuestions(questionsCopy);
        setOldQuestions(JSON.parse(JSON.stringify(questionsCopy)));

        onChange({
          ...data,
          status: parseInt(data.status, 10),
          date: new Date(data.date),
          hour: data.hour,
          end_date: new Date(data.end_date),
          end_hour: data.end_hour,
          address_id: responseAddress.data.id,
          event_id: response.data.id,
          questions: questionsCopy,
        });
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire('Oops...', 'Erro ao salvar os dados!');
        }
      } finally {
        setLoading(false);
        setLoadingText('Carregando...');
      }
    },
    [
      addressId,
      eventId,
      events,
      fileRegulation,
      loading,
      location.pathname,
      oldQuestions,
      onChange,
      questions,
      typeId,
    ]
  );

  useImperativeHandle(
    ref,
    () => ({
      submit: () => {
        formRef.current?.submitForm();
      },
    }),
    []
  );

  const handleRegulationFile = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { files } = e.target;
      if (!files || files.length === 0) {
        return;
      }

      if (files[0].type === 'application/pdf') {
        const file = files[0];
        const fileFormData = new FormData();
        fileFormData.append('file', file);
        fileFormData.append('folder', 'events');

        setFileRegulation(file);
      } else {
        e.target.value = '';

        Swal.fire({
          icon: 'error',
          title: 'Arquivo inválido!',
          text: 'O arquivo deve ser um PDF.',
        });
      }
    },
    []
  );

  const handleClearRegulationFile = useCallback(() => {
    setFileRegulation(null);
  }, []);

  return (
    <Container
      ref={formRef}
      initialData={initialBasicData}
      onSubmit={handleSubmit}
      className="row"
    >
      <Input type="hidden" name="event_id" value={eventId} className="d-none" />
      <div className="col-12">
        <h2 className="h4 fw-semibold text-center mt-5">1- Dados básicos</h2>
      </div>
      <div className="col-lg-4 px-lg-2 mt-3">
        <h3 className="h6 fw-normal">Nome do evento</h3>
        <Input
          name="name"
          type="text"
          onChange={(e) => onChangeEventName(e.target.value)}
          className="input"
        />
      </div>
      <div
        className={`${
          eventStatus === 'Rascunho' ||
          eventStatus === 'Cadastrando' ||
          eventStatus === 'Em Alteração'
            ? ''
            : 'pe-none'
        } col-lg-2 px-lg-2 mt-3`}
      >
        <h3 className="h6 fw-normal">Esporte</h3>
        <Select
          name="type"
          className="input"
          options={types.sort((a, b) => a.value.localeCompare(b.value))}
          onChange={handleChangeType}
          placeholder="Selecione"
          disabled={
            eventStatus !== 'Rascunho' &&
            eventStatus !== 'Cadastrando' &&
            eventStatus !== 'Em Alteração'
          }
        />
      </div>
      <div className="col-lg-2 px-lg-2 mt-3">
        <h3 className="h6 fw-normal">Data Inicio</h3>
        <InputDate
          className="py-1"
          name="date"
          selected={new Date(date.setHours(20, 0, 0, 0))}
          onChange={handleChangeDate}
          colorSvg="#5D5D5D"
        />
      </div>
      <div className="col-lg-1 px-lg-2 mt-3">
        <h3 className="h6 fw-normal">H Início</h3>
        <InputMask
          kind="custom"
          name="hour"
          options={{ mask: '99:99' }}
          placeholder="HH:MM"
          className="height-hour px-2 py-1"
          onChange={handleChangeStartHour}
          value={startHour}
        />
        {hourStartError && (
          <small className="d-block text-center text-danger">
            {hourStartError}
          </small>
        )}
      </div>
      <div className="col-lg-2 px-lg-2 mt-3">
        <h3 className="h6 fw-normal">Data Fim</h3>
        <InputDate
          className="py-1"
          name="end_date"
          selected={new Date(endDate.setHours(20, 0, 0, 0))}
          onChange={handleChangeEndDate}
          colorSvg="#5D5D5D"
        />
      </div>
      <div className="col-lg-1 px-lg-2 mt-3">
        <h3 className="h6 fw-normal">H Fim</h3>
        <InputMask
          name="end_hour"
          kind="custom"
          options={{ mask: '99:99' }}
          placeholder="HH:MM"
          className="height-hour px-2 py-1"
          onChange={handleChangeEndHour}
          value={endHour}
        />
        {hourEndError && (
          <small className="d-block text-center text-danger">
            {hourEndError}
          </small>
        )}
      </div>
      <div className="col-lg-2 px-lg-2 mt-3">
        <h3 className="h6 fw-normal">Status</h3>
        <Select
          name="status"
          className="input"
          options={status}
          placeholder="Selecione"
          disabled={status.length <= 1}
        />
      </div>
      <div className="col-lg-10 px-lg-2 mt-3">
        <h3 className="h6 fw-normal">Endereço</h3>
        <Input
          type="hidden"
          name="address_id"
          value={addressId}
          className="d-none"
        />
        <InputAddress
          name="address"
          className="input"
          onChange={handleChangeAddress}
          onChangeFormatted={handleChangeAddressFormatted}
          value={address}
        />
        <Input type="hidden" name="street" value={street} className="d-none" />
        <Input type="hidden" name="number" value={number} className="d-none" />
        <Input type="hidden" name="city" value={city} className="d-none" />
        <Input
          type="hidden"
          name="neighborhood"
          value={neighborhood}
          className="d-none"
        />
        <Input type="hidden" name="state" value={state} className="d-none" />
        <Input
          type="hidden"
          name="zipCode"
          value={zipCode}
          className="d-none"
        />
        <Input
          type="hidden"
          name="country"
          value={country}
          className="d-none"
        />
      </div>

      <div className="col-12 px-lg-2 mt-3">
        <iframe
          src={`https://www.google.com/maps/embed/v1/place?key=${
            process.env.REACT_APP_MAPS_KEY
          }&q=${addressMap}&zoom=${addressMap === 'Brazil' ? 2 : 15}`}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="map"
        />
      </div>
      <div className="col-12 px-lg-2 mt-3">
        <h3 className="h6 fw-normal">Descrição</h3>

        <ReactQuill
          className="textarea texts"
          value={description}
          onChange={handleDescription}
          theme="snow"
          modules={modules}
        />
        <Input
          type="hidden"
          name="description"
          className="d-none"
          value={description}
        />
      </div>
      <div className="col-12 px-lg-2 mt-4">
        <h3 className="h6 fw-normal">
          Subir arquivo .pdf de regulamento do evento (opcional)
        </h3>
        <Input
          type="file"
          name="regulation_file"
          className="d-none"
          id="regulation_file"
          onChange={handleRegulationFile}
        />
        <div className="d-flex align-items-center border rounded input h-auto p-1">
          <label
            htmlFor="regulation_file"
            className="btn-upload text-white text-center py-1 px-3 border-0"
          >
            Escolher arquivo
          </label>
          {fileRegulation?.name && (
            <span className="ms-3 d-inline-flex">
              {fileRegulation?.name}
              <button
                type="button"
                onClick={handleClearRegulationFile}
                className="border-0 bg-transparent ms-2 d-flex position-relative top-0 start-0"
              >
                <KrClose size={10} color="#8c8c8c" />
              </button>
            </span>
          )}
        </div>
      </div>
      <div
        className={`${
          eventStatus === 'Rascunho' ||
          eventStatus === 'Cadastrando' ||
          eventStatus === 'Em Alteração'
            ? ''
            : 'pe-none'
        } col-12 px-lg-2 mt-3`}
      >
        <Questions
          eventStatus={eventStatus}
          sold={sold}
          onChange={handleChangeQuestions}
          questions={questions}
        />
      </div>
      <Loading active={loading} text={loadingText} />
    </Container>
  );
};

export default forwardRef(BasicData);
